import React, { useEffect, useRef } from "react";
import { FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { detailedResultState } from "../../utils/recoil";
import DetailedResultContent from "./DetailedResultContent";
import { dummyDetailedReport, dummyPreviewResult } from "./dummyPreviewData";

const DetailedResultPreviewModal = ({ onClose }) => {
  const navigate = useNavigate();
  const [currentDetailedResult, setDetailedResult] =
    useRecoilState(detailedResultState);
  const previousDetailedResult = useRef(currentDetailedResult);

  useEffect(() => {
    const detailedResultBeforePreview = previousDetailedResult.current;
    setDetailedResult(dummyDetailedReport);

    return () => {
      setDetailedResult(detailedResultBeforePreview);
    };
  }, [setDetailedResult]);

  return (
    <div className="result-popup-overlay result-preview-overlay" role="presentation">
      <div
        className="result-popup result-preview-popup"
        role="dialog"
        aria-modal="true"
        aria-label="Detailed report preview"
      >
        <button
          type="button"
          className="result-popup-close result-preview-close"
          onClick={onClose}
          aria-label="Close preview popup"
        >
          <FaTimes />
        </button>
        <p className="result-preview-notice">
          This is sample data. It is not related to you or your test. To see
          your personalized result,{" "}
          <button
            type="button"
            className="result-preview-notice-highlight"
            onClick={() => navigate("/home")}
          >
            proceed to payment
          </button>
          .
        </p>
        <DetailedResultContent
          data={dummyDetailedReport}
          images={dummyDetailedReport.image_urls}
          resultOverride={dummyPreviewResult}
          showAppointmentCard={false}
          className="detailed-result-preview-content"
        />
      </div>
    </div>
  );
};

export default DetailedResultPreviewModal;
